import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {DisposeBag} from "../modules/DisposeBag";
import {DebounceFactory} from "../modules/DebounceModule";
import {StateService} from "@uirouter/angularjs";
import {ActivityDto} from "../model/ActivityDto";
import {ActivityQueryDto} from "../model/ActivityQueryDto";
import {Guid} from "guid-typescript";
import {ConfigService} from "../modules/ConfigModule";

class ActivityTableController implements IComponentController {
    private customerGuid: Guid;
    private disposeBag = new DisposeBag();
    private records: ActivityDto[];
    private userGuid: Guid;
    private completed: boolean;
    private dueToday: boolean;
    private activityGuid: Guid;
    private previousActivityGuid: Guid;

    constructor(private $dataHub: DataHubService, private $scope, private $debounce: DebounceFactory,
                private $config: ConfigService,
                private $state: StateService,
                private $uibModal) {
        $dataHub.onConnected(this.reloadDebounce, this.disposeBag);
        $dataHub.bindAllActivity(() => this.records, this.disposeBag);
    }

    reload = () => {
        if(!this.$dataHub.isConnected) return;
        let query = new ActivityQueryDto();
        query.customerGuid = this.customerGuid;
        query.userGuid = this.userGuid;
        query.completed = this.completed;
        query.dueToday = this.dueToday;
        query.activityGuid = this.activityGuid;
        console.log(query);
        this.$dataHub.activitySubscribeAndQuery(query)
            .then(ret => {
                this.records = ret;
            })
            .catch(this.$dataHub.defaultErrorHandler);
    };

    reloadDebounce = this.$debounce(this.reload, 1000, false);

    $onInit(): void {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.reloadDebounce();
    }

    $onDestroy?() {
        this.disposeBag.finalize();
    }


    view(record: ActivityDto) {
        this.$uibModal.open({
            component: 'activityView',
            size: 'md',
            resolve: {
                record: () => record,
                customerGuid: () => this.customerGuid
            }
        })
    }
}

export default angular.module('component.activityTable', [])
    .component('activityTable', {
        template: require('./ActivityTable.html'),
        controller: ActivityTableController,
        bindings: {
            customerGuid: '<',
            userGuid: '<',
            completed: '<',
            dueToday: '<',
            activityGuid: '<',
            previousActivityGuid: '<'
        }
    }).name;
